import "@/App.css";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TriarchLayout } from "@/components/triarch/TriarchLayout";
import { Loader } from "@/components/triarch/Loader";
import HomePage from "@/pages/HomePage";
import ProtocolPage from "@/pages/ProtocolPage";
import OrchestraPage from "@/pages/OrchestraPage";
import ArchivePage from "@/pages/ArchivePage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  // Shown only on initial site entry. Because <App /> mounts once, this
  // naturally does NOT re-trigger on client-side route changes, but will
  // appear again on a hard refresh.
  const [loading, setLoading] = useState(true);

  const handleLoaderDone = () => {
    setLoading(false);
    if (typeof window !== "undefined") {
      window.__triarchLoaderDone = true;
      window.dispatchEvent(new Event("triarch:loader-done"));
    }
  };

  return (
    <div className="App">
      <AnimatePresence mode="wait">
        {loading && <Loader key="triarch-loader" onDone={handleLoaderDone} />}
      </AnimatePresence>
      <BrowserRouter>
        <Routes>
          <Route element={<TriarchLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/protocol" element={<ProtocolPage />} />
            <Route path="/orchestra" element={<OrchestraPage />} />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="*" element={<HomePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(11,13,16,0.92)",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#F2F4F7",
            backdropFilter: "blur(16px)",
            fontFamily: "'IBM Plex Mono', ui-monospace, monospace",
            letterSpacing: "0.04em",
          },
        }}
      />
    </div>
  );
}

export default App;
